// extracted by mini-css-extract-plugin
module.exports = {"track":"Switch_track__ljzIT","thumb":"Switch_thumb__uePnR","thumbChecked":"Switch_thumbChecked__RjKe1"};